const EVENT_NAME = "fonts:ready";
const CLASS_NAME = "fonts-loaded";


export function onFontsReady(cb, timeoutMs = 800) {
  if (document.documentElement.classList.contains(CLASS_NAME)) {
    cb();
    return;
  }

  let done = false;
  const runOnce = () => {
    if (done) return;
    done = true;
    cb();
  };

  const t = setTimeout(runOnce, timeoutMs);

  window.addEventListener(
    EVENT_NAME,
    () => {
      clearTimeout(t);
      runOnce();
    },
    { once: true }
  );
}
